import Vue from 'vue'
import { s } from '../functions'

export const Functions = Vue.extend({
  methods: {
    s: s
  }
})
